export default __webpack_public_path__ + "static/media/matt-pic-modified.dd638491.jpeg";